import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {},
    chip: {
        padding: theme.spacing(1, 2),
        border: `1px solid ${theme.colors.gray[200]}`,
    },
    activeChip: {
        border: `1px solid ${theme.colors.primary.main}`,
    },
    chipContent: Object.assign(Object.assign({}, theme.typography.subtitle1), { color: theme.colors.text[900] }),
    menu: {},
    menuPaper: {
        marginTop: theme.spacing(0.5),
        boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.08)',
        borderRadius: 8,
        overflow: 'visible',
    },
    menuContent: Object.assign(Object.assign({}, theme.typography.body2), { padding: theme.spacing(0, 1) }),
}));
//# sourceMappingURL=BaseFilterMenu.styles.js.map